export enum TaxTabs {
  TAX_CERTIFICATE = 'TAX_CERTIFICATE',
  REDEMPTION_REQUEST = 'REDEMPTION_REQUEST',
  PAYMENT_APPROVAL = 'PAYMENT_APPROVAL',
  PAYMENT_TAPE_APPROVAL = 'PAYMENT_TAPE_APPROVAL',
};

export enum PaymentApprovalFilter {
  PENDING = 'PENDING',
  ALL = 'ALL',
  TAPE = 'TAPE',
}